export default __webpack_public_path__ + "images/1e30484d992c236abbd210df3e44a7b5.svg";